const play = {
  account: {
    address: 'Endereço',
    addressNotInformed: 'Endereço não informado',
    back: 'Voltar',
    backHome: 'Voltar ao início',
    change: 'Alterar',
    changePassword: 'Alterar senha',
    changePasswordDescription:
      'Informe sua senha atual e defina uma nova senha para acessar sua conta.',
    changePicture: 'Alterar foto',
    cepLookupError: 'Não foi possível buscar o CEP informado.',
    cityPlaceholder: 'Buscar cidade',
    citySearchPlaceholder: 'Digite a cidade',
    editProfile: 'Editar perfil',
    fallbackUser: 'Usuário',
    favorites: 'Favoritas',
    greeting: 'Olá, {{firstName}}.',
    heroSubtitle: 'Acompanhe suas partidas, preferências e histórico.',
    loadErrorDescription: 'Tente novamente em instantes.',
    loadErrorTitle: 'Não foi possível carregar sua conta',
    password: 'Senha',
    passwordHint: 'Use uma senha com pelo menos 8 caracteres.',
    passwordStatus: 'Proteja sua conta mantendo uma senha atualizada.',
    personalData: 'Dados pessoais',
    pictureReadError: 'Não foi possível ler a imagem selecionada.',
    quickActionsTitle: 'Acesso rápido',
    removePicture: 'Remover foto',
    save: 'Salvar alterações',
    savePassword: 'Salvar senha',
    sectionLabel: 'Minha conta',
    security: 'Segurança',
    securityHint: 'Gerencie opções de acesso e proteção da sua conta.',
    selectPlaceholder: 'Selecionar',
    signOut: 'Sair',
    sportsTitle: 'Seus esportes',
    subtitle: 'Atualize seus dados para agilizar reservas e confirmações.',
    title: 'Minha conta',
    nextMatch: {
      title: 'Próxima partida',
      viewAll: 'Ver todas →',
    },
    quickActions: {
      reservations: {
        label: 'Minhas reservas',
        sub: 'Próximas e histórico',
      },
      favorites: {
        label: 'Favoritas',
        sub_one: '{{count}} quadra salva',
        sub_other: '{{count}} quadras salvas',
      },
      details: {
        label: 'Dados da conta',
        sub: 'Nome, CPF, senha',
      },
    },
    stats: {
      upcoming: 'Próximas',
      completed: 'Jogadas',
      venues: 'Locais',
    },
    sports: {
      gamesCount_one: '{{count}} jogo',
      gamesCount_other: '{{count}} jogos',
    },
    fields: {
      birthDate: 'Data de nascimento',
      city: 'Cidade',
      complement: 'Complemento',
      cpf: 'CPF',
      confirmPassword: 'Confirmar nova senha',
      currentPassword: 'Senha atual',
      email: 'E-mail',
      gender: 'Gênero',
      name: 'Nome completo',
      neighborhood: 'Bairro',
      newPassword: 'Nova senha',
      number: 'Número',
      phone: 'Telefone',
      street: 'Rua',
      zipCode: 'CEP',
    },
    placeholders: {
      birthDate: 'dd/mm/aaaa',
      complement: 'Apto, bloco ou referência',
      cpf: '000.000.000-00',
      email: 'voce@email.com',
      name: 'Nome e sobrenome',
      neighborhood: 'Ex.: Centro',
      number: 'Ex.: 123',
      phone: '(11) 91234-5678',
      street: 'Ex.: Rua das Flores',
      zipCode: '00000-000',
    },
    gender: {
      FEMALE: 'Feminino',
      MALE: 'Masculino',
      OTHER: 'Outro',
      none: 'Não informar',
    },
    validation: {
      confirmPasswordRequired: 'Confirme a nova senha',
      currentPasswordRequired: 'Informe sua senha atual',
      passwordMinLength: 'A senha deve ter pelo menos 8 caracteres',
      passwordMismatch: 'As senhas não conferem',
    },
    bookingFavorites: {
      bookingCount_one: '1 reserva',
      bookingCount_other: '{{count}} reservas',
      courtsDescription: 'Ranking gerado pelo seu histórico de reservas.',
      courtsTitle: 'Quadras mais reservadas',
      description: 'Atalhos calculados automaticamente pelas reservas feitas com sua conta.',
      emptyDescription:
        'Quando você fizer reservas, suas quadras e esportes mais frequentes aparecem aqui.',
      emptyTitle: 'Sem histórico de reservas ainda',
      errorDescription: 'Tente novamente para atualizar seus rankings de reservas.',
      errorTitle: 'Não foi possível carregar seus favoritos automáticos',
      eyebrow: 'Histórico',
      noCourts: 'Nenhuma quadra recorrente ainda.',
      noSports: 'Nenhum esporte recorrente ainda.',
      retry: 'Tentar novamente',
      searchCourts: 'Buscar quadras',
      sportsDescription: 'Use para filtrar a busca pelo que você mais joga.',
      sportsTitle: 'Esportes mais reservados',
      title: 'Favoritos automáticos',
      viewReservations: 'Ver reservas',
    },
  },
  auth: {
    hero: {
      badge: 'Partiu jogar',
      title: 'Sua quadra,',
      titleHighlight: 'pronta em 3 cliques.',
      subtitle:
        'O jeito mais rápido de reservar futsal, padel, beach tennis, vôlei e mais perto de você.',
      byline: 'by Quadralize',
      copyright: '© {{year}} Quadralize · PartiuQuadra',
      explore: 'Explorar sem login',
      facts: {
        clicksValue: '3',
        clicksLabel: 'Cliques p/ reservar',
        callsValue: '0',
        callsLabel: 'Ligações',
        feeValue: 'R$ 0',
        feeLabel: 'Taxa de reserva',
      },
    },
    fields: {
      email: 'E-mail opcional',
      emailPlaceholder: 'seu@email.com',
      name: 'Nome completo',
      namePlaceholder: 'Como devemos te chamar',
      password: 'Senha',
      passwordPlaceholder: '••••••••',
      phone: 'Telefone',
      phonePlaceholder: '(11) 91234-5678',
    },
    divider: 'ou',
    oauth: {
      connecting: 'Conectando…',
      google: 'Continuar com Google',
      feedback: {
        browser:
          'Este navegador bloqueou a entrada com Google. Tente novamente ou entre com telefone.',
        cancelled: 'Janela do Google fechada. Quando quiser, toque para tentar de novo.',
        configuration:
          'A entrada com Google não está configurada para este endereço. Use localhost ou revise a configuração.',
        generic: 'Não conseguimos concluir a entrada com Google. Tente novamente em instantes.',
        toastTitle: 'Não foi possível entrar com Google',
        unavailable: 'A janela do Google não abriu agora. Tente novamente em instantes.',
      },
    },
    login: {
      kicker: 'Entrar',
      title: 'Partiu voltar à quadra',
      subtitle: 'Entre pra continuar reservando em segundos.',
      forgotPassword: 'Esqueci a senha',
      submit: 'Entrar',
      noAccount: 'Novo no PartiuQuadra?',
      signUp: 'Criar conta',
    },
    register: {
      kicker: 'Cadastro',
      title: 'Crie sua conta',
      subtitle: 'Leva 30 segundos. Sem burocracia, sem ligação.',
      passwordHint: 'Mínimo de 6 caracteres.',
      submit: 'Criar conta',
      terms: 'Ao criar a conta você aceita os Termos e a Privacidade do PartiuQuadra.',
      haveAccount: 'Já tem conta?',
      signIn: 'Entrar',
    },
    forgot: {
      kicker: 'Recuperar senha',
      title: 'Esqueceu a senha?',
      subtitle: 'Informe o telefone da conta e enviaremos um código pra redefinir sua senha.',
      submit: 'Enviar código',
      codeSent:
        'Código enviado para o telefone {{phone}}. Informe abaixo o código recebido para continuar.',
      codeLabel: 'Código de recuperação',
      codePlaceholder: '123456',
      invalidCode: 'Código de recuperação inválido',
      validateCode: 'Validar código',
      resendCode: 'Reenviar código',
      codeValidated:
        'Código validado para {{phone}}. Defina sua nova senha para concluir a recuperação.',
      newPassword: 'Nova senha',
      confirmNewPassword: 'Confirmar nova senha',
      resetSubmit: 'Alterar senha',
      remembered: 'Lembrou a senha?',
      backToLogin: 'Voltar para entrar',
      doneKicker: 'Tudo certo',
      doneTitle: 'Senha redefinida',
      doneSubtitle: 'Sua senha foi alterada com sucesso para a conta do telefone {{phone}}.',
      doneCardTitle: 'Senha atualizada',
      doneCardHint: 'Agora é só entrar com a nova senha.',
    },
  },
  booking: {
    kicker: 'Reservar',
    steps: {
      confirm: 'Confirmação',
      data: 'Dados',
      equipment: 'Equipamento',
      time: 'Horário',
    },
    stepProgress: 'Etapa {{current}} de {{total}}',
    actions: {
      back: 'Voltar',
      cancel: 'Cancelar',
      confirm: 'Confirmar reserva',
      continue: 'Continuar',
      review: 'Revisar reserva',
    },
    durations: {
      long: '2h',
      medium: '1h30',
      short: '1h',
    },
    equipment: {
      decrease: 'Diminuir {{name}}',
      empty: 'Nenhum equipamento disponível para este horário.',
      error: 'Não foi possível carregar os equipamentos.',
      increase: 'Aumentar {{name}}',
      intro: 'Escolha o que quer alugar. Fica separado para você no balcão.',
      items: 'Avulsos',
      kits: 'Kits',
      loading: 'Carregando equipamentos…',
      paidAtCounter: 'pago no balcão ao retirar',
      quantity: 'Quantidade de {{name}}',
      overLimit_one: 'Só resta {{count}} nesse horário. Diminua a quantidade.',
      overLimit_other: 'Só restam {{count}} nesse horário. Diminua a quantidade.',
      overSoldOut: 'Esgotado nesse horário. Remova este item.',
      remaining_one: 'Resta {{count}} nesse horário',
      remaining_other: 'Restam {{count}} nesse horário',
      retry: 'Tentar novamente',
      skip: 'Pular, tenho o meu',
      soldOut: 'Esgotado nesse horário',
      termAccept: 'Li e aceito',
      termError: 'Não foi possível carregar o termo de responsabilidade.',
      termLoading: 'Carregando termo de responsabilidade…',
      termTitle: 'Termo de responsabilidade',
      title: 'Quer alugar equipamento?',
      total: 'Total do equipamento',
      unitPrice: '{{price}} cada',
    },
    footer: {
      quoting: 'Cotando…',
      total: 'Total',
    },
    step1: {
      availableTimes: 'Horários disponíveis',
      court: 'Quadra',
      date: 'Data',
      duration: 'Duração',
      empty: 'Sem horários cadastrados para esta data.',
      loadingTimes: 'Atualizando',
      peak: 'Pico',
      retry: 'Tentar novamente',
      sport: 'Esporte',
      taken: 'Ocupado',
      timesError: 'Não foi possível carregar os horários desta data.',
    },
    step2: {
      fields: {
        cpf: 'CPF',
        email: 'E-mail',
        name: 'Nome',
        phone: 'Telefone',
      },
      gateDescription:
        'Com uma conta seus dados ficam salvos e você acompanha a reserva de qualquer lugar.',
      gateTitle: 'Como quer continuar?',
      notesLabel: 'Observações (opcional)',
      notesPlaceholder: 'Ex: levar cones, trio jogando...',
      paymentDescription: 'Pix, cartão ou dinheiro. Sem taxa antecipada.',
      paymentTitle: 'Pagamento na quadra',
      reviewHint: 'Confira seus dados. Enviaremos confirmação por e-mail e WhatsApp.',
      signIn: 'Entrar na conta',
      signUp: 'Criar conta grátis',
    },
    step3: {
      bookingFee: 'Taxa de reserva',
      courtLine: 'Quadra · {{duration}}',
      date: 'Data',
      duration: 'Duração',
      equipmentLine: '{{quantity}}× {{name}}',
      equipmentPaidAtCounter: 'pago no balcão ao retirar',
      free: 'Grátis',
      notes: 'Observações',
      player: 'Dados do jogador',
      priceFootnote: 'Pagamento direto na quadra. Cancelamento gratuito até 6h antes.',
      priceLabel: 'Valor',
      quoteError: 'Não foi possível cotar este horário. Escolha outro horário ou tente novamente.',
      sport: 'Modalidade',
      time: 'Horário',
      total: 'Total',
    },
    success: {
      backHome: 'Voltar à home',
      code: 'Código',
      confirmed: 'Confirmada',
      equipmentCodeHint: 'Mostre o código da reserva no balcão',
      equipmentLine: '{{quantity}}× {{name}}',
      equipmentTitle: 'Separado para você no balcão',
      kicker: 'Reserva confirmada',
      kv: {
        court: 'Quadra',
        date: 'Data',
        sport: 'Esporte',
        time: 'Horário',
      },
      subtitle: 'Enviamos os detalhes pro seu e-mail e WhatsApp.',
      title: 'Partiu jogar!',
      viewReservations: 'Ver minhas reservas',
      viewReservationsShort: 'Ver reservas',
    },
  },
  brand: {
    name: 'PartiuQuadra',
    tagline: 'Portal do jogador',
  },
  favorites: {
    back: 'Voltar',
    kicker: 'Conta',
    title: 'Quadras favoritas',
    subtitle_one: '{{count}} quadra salva',
    subtitle_other: '{{count}} quadras salvas',
    findMore: 'Encontrar mais quadras',
    quickAccess: 'Acesso rápido',
    count_one: '{{count}} quadra favorita',
    count_other: '{{count}} quadras favoritas',
    description: 'Suas escolhas ficam salvas neste dispositivo para reservar mais rápido.',
    viewInSearch: 'Ver na busca',
    emptyTitle: 'Sua lista de favoritas está vazia',
    emptyDescription: 'Salve quadras pela busca para voltar nelas rapidamente quando for reservar.',
    searchCourts: 'Buscar quadras',
    venueErrorTitle: 'Não foi possível carregar esta quadra',
    venueErrorDescription: 'Ela pode estar indisponível no momento.',
    removeFavorite: 'Remover dos favoritos',
  },
  home: {
    hero: {
      badge: 'Partiu jogar',
      title: 'Sua quadra,',
      titleHighlight: 'pronta em 3 cliques.',
      subtitle:
        'Reserve quadras de futsal, padel, beach tennis, vôlei e mais em {{city}}. Sem WhatsApp, sem ligação, sem taxa.',
      ctaSearch: 'Buscar quadras',
      ctaHighlights: 'Ver destaques',
      cityFallback: 'sua cidade',
      searchPlaceholder: 'Buscar por bairro ou quadra…',
      locationPrefix: 'Você está em',
      stats: {
        venuesLabel: 'Arenas',
        sportsLabel: 'Esportes',
        coveredLabel: 'Cobertas',
        minPriceLabel: 'A partir de/h',
      },
    },
    sports: {
      title: 'Escolha seu esporte',
      hint: 'Populares hoje',
    },
    trending: {
      title: 'Em alta perto de você',
      viewAll: 'Ver todas →',
    },
    promo: {
      today: 'Hoje',
      highlight_one: '{{count}} quadra',
      highlight_other: '{{count}} quadras',
      rest_one: 'livre pra jogar já.',
      rest_other: 'livres pra jogar já.',
      cta: 'Jogar agora',
    },
    nextMatch: {
      label: 'Próxima partida',
      statusConfirmed: 'Confirmada',
      statusPending: 'Pendente',
      viewAll: 'Ver todas minhas reservas',
    },
    managerPromo: {
      kicker: 'Quadralize para gestores',
      title: 'Você é dono de quadra?\nAumente sua ocupação com o Quadralize.',
      description:
        'O quadralize.com.br é o sistema principal para gestão de quadras: reservas online, controle financeiro e operação diária em um só lugar.',
      ctaPrimary: 'Quero cadastrar minha quadra',
      ctaSecondary: 'Falar com especialista',
      benefits: [
        '+40% em reservas recorrentes',
        'Gestão de horários e bloqueios',
        'Check-in e confirmações automáticas',
      ],
    },
  },
  footer: {
    tagline:
      'Tecnologia para quem vive o esporte. Conectamos atletas e gestores de quadra com uma experiência simples e eficiente.',
    platform: {
      title: 'Plataforma',
      search: 'Buscar quadras',
      reservations: 'Minhas reservas',
      owners: 'Sistema para donos',
    },
    social: {
      title: 'Redes sociais',
    },
    copyright: '© {{year}} Quadralize. Todos os direitos reservados.',
  },
  search: {
    kicker: 'Buscar',
    title: 'Quadras em {{city}}',
    subtitle_one: '{{count}} local disponível pra jogar hoje',
    subtitle_other: '{{count}} locais disponíveis pra jogar hoje',
    back: 'Voltar',
    mobileTitle: 'Buscar quadras',
    filters: {
      query: 'Busca',
      queryPlaceholder: 'Bairro, arena...',
      sport: 'Esporte',
      cover: 'Cobertura',
      floor: 'Tipo de piso',
      allSports: 'Todos',
      allCovers: 'Todas',
      allFloors: 'Todos',
      covered: 'Coberta',
      open: 'Aberta',
      quick: 'Rápido',
      quickAll: 'Todos',
      favorites: 'Favoritas',
      openFilters: 'Abrir filtros',
      clearSearch: 'Limpar busca',
      clearAll: 'Limpar tudo',
      searchPrefix: 'Busca: {{query}}',
      sortPrefix: 'Ordenação: {{label}}',
    },
    sort: {
      distance: 'Mais próximas',
      price: 'Menor preço',
    },
    results: {
      loading: 'Buscando quadras...',
      refreshing: 'Atualizando...',
      count_one: 'quadra',
      count_other: 'quadras',
      showing: 'mostrando em lista e mapa',
      found_one: 'quadra encontrada',
      found_other: 'quadras encontradas',
    },
    empty: {
      title: 'Nada por aqui',
      description: 'Tente outro filtro ou esporte.',
      favoritesTitle: 'Nenhuma favorita nos filtros atuais',
      favoritesDescription: 'Remova o filtro de favoritas ou salve novas quadras pela busca.',
      filteredDescription: 'Ajuste a busca ou remova alguns filtros para ampliar os resultados.',
      locationDescription:
        'Não encontramos quadras para esta localização. Tente outra cidade/CEP ou ajuste os filtros.',
      clear: 'Limpar filtros',
      changeLocation: 'Alterar localização',
    },
    error: {
      title: 'Não foi possível carregar as quadras',
      description: 'A conexão com as quadras falhou. Tente novamente ou ajuste os filtros.',
      retry: 'Tentar novamente',
    },
    map: {
      points_one: '{{count}} local',
      points_other: '{{count}} locais',
      watermark: '· mapa estilizado · placeholder ·',
      ariaLabel: 'Mapa estilizado das quadras',
      pinLabel: 'Ver detalhes de {{venueName}}',
    },
  },
  reservations: {
    back: 'Voltar',
    kicker: 'Minhas reservas',
    title: 'Suas partidas',
    subtitle: '{{upcoming}} confirmadas · {{history}} no histórico',
    new: 'Nova reserva',
    newShort: 'Nova',
    tabs: {
      upcoming: 'Próximas',
      history: 'Histórico',
    },
    metrics: {
      next: 'Próxima reserva',
      nextEmptyTitle: 'Nenhuma reserva marcada',
      nextEmptyDescription: 'Reserve uma quadra para acompanhar seus horários aqui.',
      upcoming: 'Próximas',
      completed: 'Realizadas',
      scheduled: 'Agendado',
    },
    empty: {
      loadingTitle: 'Carregando reservas',
      loadingDescription: 'Buscando seus horários confirmados.',
      errorTitle: 'Não foi possível carregar',
      errorDescription: 'Tente novamente para atualizar suas reservas.',
      retry: 'Tentar novamente',
      title: 'Nenhuma reserva por aqui',
      upcomingDescription: 'Quando você reservar uma quadra, ela aparece aqui.',
      historyDescription: 'Histórico vazio nessa categoria.',
      searchCourts: 'Buscar quadras',
    },
    card: {
      value: 'Valor',
    },
    status: {
      confirmed: 'Confirmada',
      pending: 'Pendente',
      completed: 'Concluída',
      cancelled: 'Cancelada',
    },
    detail: {
      kicker: 'Reserva',
      code: 'Código',
      backLink: 'Voltar às reservas',
      share: 'Compartilhar',
      agenda: 'Agenda',
      kv: {
        date: 'Data',
        time: 'Horário',
        duration: 'Duração',
        sport: 'Modalidade',
        court: 'Quadra',
        value: 'Valor',
      },
      paymentNotice:
        'O pagamento é feito diretamente na quadra. Chegue 10 minutos antes. Para cancelar, faça isso com pelo menos 6 horas de antecedência.',
      historicalNotice: 'Esta reserva já aconteceu.',
      equipmentTitle: 'Separado para você no balcão',
      equipmentCodeHint: 'Mostre o código da reserva no balcão',
      equipmentLine: '{{quantity}}× {{name}}',
      actionsTitle: 'Ações',
      actions: {
        directions: 'Chegar',
        invite: 'Convidar',
        call: 'Ligar',
        agenda: 'Agenda',
      },
      addressNotInformed: 'Endereço não informado',
      phoneNotInformed: 'Telefone não informado',
      shareCopied: 'Detalhes da reserva copiados',
      shareError: 'Não foi possível compartilhar a reserva',
      cancel: 'Cancelar reserva',
      loadingTitle: 'Carregando reserva',
      loadingDescription: 'Buscando os detalhes da sua reserva.',
      errorTitle: 'Não foi possível carregar',
      errorDescription: 'Tente novamente para atualizar os detalhes da reserva.',
      retry: 'Tentar novamente',
      notFoundTitle: 'Reserva não encontrada',
      notFoundDescription: 'O código pode estar incorreto ou a reserva foi removida.',
    },
  },
  nav: {
    createAccount: 'Criar conta',
    discover: 'Descobrir',
    favorites: 'Favoritas',
    myAccount: 'Minha conta',
    myReservations: 'Minhas reservas',
    profile: 'Perfil',
    reservations: 'Reservas',
    search: 'Buscar',
    searchCourts: 'Buscar quadras',
    sectionAccount: 'Conta',
    sectionPlay: 'Jogar',
    signIn: 'Entrar',
    signOut: 'Sair',
  },
  topbar: {
    accountMenu: 'Abrir menu da conta',
    playNow: 'Jogar agora',
    searchPlaceholder: 'Buscar por bairro, arena ou esporte…',
    updateLocation: 'Atualizar localização',
  },
  venueDetail: {
    contactTitle: 'Fale direto com a arena',
    whatsapp: 'WhatsApp',
    cta: 'Ver horários e reservar',
    ctaFootnote: 'Reserva gratuita. Cancelamento até 6h antes.',
    dateLabel: 'Data',
    error: {
      backSearch: 'Voltar para busca',
      description: 'O endereço pode estar incorreto ou a arena pode estar indisponível no momento.',
      goHome: 'Ir para início',
      title: 'Não foi possível carregar esta quadra',
    },
    hours: 'Horário de funcionamento',
    hoursEmpty: 'Horários serão confirmados no momento da reserva.',
    morePhotos: '+{{count}} fotos',
    openNow: 'Aberta agora',
    paymentChip: 'Pagamento na quadra',
    perHour: '/hora',
    priceFrom: 'A partir de',
    priceVaryNote: 'Tarifas podem variar por quadra, horário e dia da semana.',
    save: 'Salvar',
    saved: 'Salva',
    share: 'Compartilhar',
    shareLinkCopied: 'Link copiado',
    shareLinkCopiedDescription: 'Cole o link para compartilhar essa quadra.',
    shareError: 'Não foi possível compartilhar',
    sportLabel: 'Modalidade',
    sports: 'Modalidades',
    visual: {
      ariaLabel: 'Resumo visual de {{venueName}}',
      heroKicker: 'Partiu jogar',
    },
    tabs: {
      courts: 'Quadras',
      info: 'Informações',
      prices: 'Preços',
    },
    viewGallery: 'ver galeria',
    weekdays: {
      d0: 'Domingo',
      d1: 'Segunda',
      d2: 'Terça',
      d3: 'Quarta',
      d4: 'Quinta',
      d5: 'Sexta',
      d6: 'Sábado',
    },
  },
  venue: {
    photoHint: 'foto · quadra',
    photoLabel: 'Foto de {{venueName}}',
    favorite: {
      add: 'Favoritar {{venueName}}',
      remove: 'Remover {{venueName}} dos favoritos',
      savedTitle: 'Quadra salva',
      savedDescription: '{{venueName}} foi adicionada às favoritas.',
      removedTitle: 'Quadra removida',
      removedDescription: '{{venueName}} saiu das favoritas.',
    },
    priceFrom: 'A partir de',
    hourlySuffix: '/h',
    perHour: 'por hora',
    covered: 'Coberta',
    open: 'Aberta',
    reserve: 'Reservar',
    viewTimes: 'Ver horários',
    distanceKm: '{{distance}} km',
  },
} as const

export default play
